interface IImage {
  height: number;
  width: number;
}

export function imageMaxZoom(imageViewport: IImage, targetImage: IImage, minZoom = 1) {
  return Math.max(minZoom, Math.round(
    Math.max(
      targetImage.height! / imageViewport.height, targetImage.width! / imageViewport.width
    )
  ));
}

export function canZoomImage(imageViewport: IImage, targetImage: IImage, minZoom = 1) {
  return minZoom < imageMaxZoom(imageViewport, targetImage, minZoom);
}
